import React, { useRef } from "react";
import styled, { createGlobalStyle } from "styled-components";
import { useReactToPrint } from "react-to-print";
import DishPDFFile from "./DishPrintLayout";
import { PiPrinterLight } from "react-icons/pi";
import { useTranslation } from "../../hooks/useTranslation";

const Wrapper = styled.div`
  position: absolute;
  left: -9999px;
  top: -9999px;
  width: 1px;
  height: 1px;
  overflow: hidden;
  @media print {
    position: static;
    left: auto;
    top: auto;
    width: auto;
    height: auto;
    overflow: visible;
  }
`;

const PageSettings = createGlobalStyle`
  @media print {
    @page {
      margin: 8mm;
    }
  }
`;

const DishFileToPrint = ({
  dish,
  parameters,
  BladeComponent,
  EthicComponent,
  ethic,
  dishData,
  sessionId,
}) => {
  const componentRef = useRef();
  const { t } = useTranslation();
  
  // Debug logging removed to satisfy hooks lint about mutable ref deps
  
  const handlePrint = useReactToPrint({
    contentRef: componentRef,
    documentTitle: `${t('Hållbarhetsdeklaration')} - ${dish?.name || t('Recept')}`,
  });
  
  const handlePrintClick = () => {
    console.log('Print button clicked');
    console.log('Component ref:', componentRef.current);
    console.log('Dish data:', dish);
    handlePrint();
  };

  return (
    <>
      <PageSettings />
      <div className="flex flex-col items-center">
        <Wrapper>
          <DishPDFFile
            dish={dish}
            parameters={parameters}
            ref={componentRef}
            ethic={ethic}
            dishData={dishData}
            BladeComponent={BladeComponent}
            EthicComponent={EthicComponent}
            t={t}
          />
        </Wrapper>
        <button onClick={handlePrintClick} id="Download-button" type="button" className={`flex justify-center border border-gray-200 rounded px-3 gap-2 cursor-pointer hover:bg-gray-50 py-2`}>
          <span
            className="flex items-center justify-center "
          >
            <PiPrinterLight className="w-5 h-5" />
          </span>
          <p className="text-sm text-gray-600">{t("Hållbarhetsrapport")}</p>
        </button>
      </div>
    </>
  );
};

export default DishFileToPrint;

// Export for potential use in other components
export { DishFileToPrint as DishReportRoot };
